import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-secure-info-pricing',
  templateUrl: './secure-info-pricing.component.html',
  styleUrls: ['./secure-info-pricing.component.scss']
})
export class SecureInfoPricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
